import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const themes = {
  dark: {
    primary: '#00D46A',
    primaryDark: '#00A854',
    background: '#0A0A0A',
    surface: '#1A1A1A',
    surfaceLight: '#151515',
    border: '#2A2A2A',
    text: '#FFFFFF',
    textSecondary: '#CCCCCC',
    textTertiary: '#909090',
    textMuted: '#808080',
    error: '#ff4444',
  },
  light: {
    primary: '#00D46A',
    primaryDark: '#00A854',
    background: '#FFFFFF',
    surface: '#F5F5F5',
    surfaceLight: '#FAFAFA',
    border: '#E0E0E0',
    text: '#0A0A0A',
    textSecondary: '#333333',
    textTertiary: '#666666',
    textMuted: '#808080',
    error: '#ff4444',
  },
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(true);

  useEffect(() => {
    const savedTheme = localStorage.getItem('syntari_theme');
    if (savedTheme) {
      setIsDarkMode(savedTheme === 'dark');
    }
  }, []);

  const toggleTheme = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    localStorage.setItem('syntari_theme', newMode ? 'dark' : 'light');
  };

  const theme = isDarkMode ? themes.dark : themes.light;

  return (
    <ThemeContext.Provider value={{ theme, isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
